// Caps a raw grid cell (width/cols x height/rows) down to the size a tile is actually painted at:
// a tile never grows past 4:3 vertically or 2.25:1 horizontally, the rest becomes centering padding.
export const getTileDisplaySize = (tileWidth: number, tileHeight: number) => {
  const maxHeight = Math.round(tileWidth * 0.75);
  const maxWidth = Math.min(tileHeight, maxHeight) * 2.25;

  return {
    maxHeight,
    maxWidth,
    displayWidth: Math.min(tileWidth, maxWidth),
    displayHeight: Math.min(tileHeight, maxHeight),
  };
};
